<div class="duration">
  <div class="time-input">
    <input
      type="number"
      pattern="\d*"
      class="time-box"
      [value]="hours"
      (input)="validateInput($event.target)"
      (blur)="handleBlur($event.target)"
      (click)="$event.target.select()"
      min="0"
      max="23"
      maxlength="2"
      name="hours"
      placeholder="00"
      autocomplete="off"
    />
    <span class="colon">:</span>
    <input
      type="number"
      pattern="\d*"
      class="time-box"
      [(ngModel)]="minutes"
      (input)="validateInput($event.target)"
      (blur)="handleBlur($event.target)"
      (click)="$event.target.select()"
      min="0"
      max="59"
      maxlength="2"
      name="minutes"
      placeholder="00"
      autocomplete="off"
    />
    <span class="colon">:</span>
    <input
      type="number"
      pattern="\d*"
      class="time-box"
      [(ngModel)]="seconds"
      (input)="validateInput($event.target)"
      (blur)="handleBlur($event.target)"
      (click)="$event.target.select()"
      min="0"
      max="59"
      maxlength="2"
      name="seconds"
      placeholder="00"
      autocomplete="off"
    />
  </div>
</div>
